import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "data-list-dialog",
  templateUrl: "./data-list-dialog.html",
  styleUrls: ["./data-list-dialog.scss"],
})
export class DataListDialog {
  constructor(
    public dialogRef: MatDialogRef<DataListDialog>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}
}
